/*
* @prop --component-dialog-width: Defines the width of the Dialog when screen > medium vp, e.g. 600px, 50vw ...
*/

:host {
  display: block;

  .dialog {
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: $z-index-dialog;

    &--hide {
      display: none;
    }

    &__overlay {
      position: fixed;
      inset: 0;
      /* stylelint-disable color-function-notation */
      background-color: rgba($color: $ui-dark, $alpha: 65%);
    }

    &__content {
      position: relative;
      width: 100%;
      max-height: calc(100% - 30px);
      margin: 15px;
      overflow: auto;

      &:focus {
        outline: none;
      }

      @include breakpoint($medium) {
        width: var(--component-dialog-width, 75%);
        margin-left: 30px;
        margin-right: 30px;
        max-height: 80vh;
      }

      @include breakpoint($desktop) {
        margin-left: 35px;
        margin-right: 35px;
      }
    }

    &__close {
      position: absolute;
      top: 0;
      right: 0;

      --component-button-padding-horizontal: 10px;
      --component-button-padding-vertical: 10px;

      @include breakpoint($medium) {
        --component-button-padding-horizontal: 20px;
        --component-button-padding-vertical: 20px;
      }
    }

    .hide-bg {
      backdrop-filter: blur(8px);
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -webkit-backdrop-filter: blur(8px);

      // backdrop-filter is not supported in Firefox
      @-moz-document url-prefix('') {
        background-color: rgba($color: $ui-dark, $alpha: 100%);
      }
    }
  }
}
